module.exports = __webpack_public_path__ + "img/header_2.7ec2112f.jpg";